import { defineMessages, useIntl } from 'react-intl'
import {
  Button,
  Box,
  Modal,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ButtonGroup,
  Heading,
  ModalBody
} from '@homebotapp/hb-react-component-catalog'
import {
  HOME_SEARCH_DISMISS_REMOVE_SAVED_SEARCH_MODAL,
  HOME_SEARCH_REMOVE_SAVED_SEARCH_MODAL_BUTTON
} from '../../../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'

export const MSG = defineMessages({
  areYouSure: {
    id: 'HomeSearch.listings.savedSearch.modal.remove.areYouSure',
    defaultMessage: 'Are you sure?'
  },
  doYouWantToDelete: {
    id: 'HomeSearch.listings.savedSearch.modal.remove.doYouWantToDelete',
    defaultMessage: 'Do you want to delete the saved search?'
  },
  primaryBtn: {
    id: 'HomeSearch.listings.savedSearch.modal.delete',
    defaultMessage: 'Yes, Delete'
  },
  secondaryBtn: {
    id: 'HomeSearch.listings.savedSearch.modal.cancel',
    defaultMessage: 'Cancel'
  }
})

export interface RemoveSavedSearchModalProps {
  showModal: boolean
  hideModal: () => void
  deleteSavedSearch: () => void
}

export const RemoveSavedSearchModal = ({ showModal, hideModal, deleteSavedSearch }: RemoveSavedSearchModalProps) => {
  const intl = useIntl()

  const handleDeleteSavedSearch = () => {
    deleteSavedSearch()
    hideModal()
  }

  return (
    <Modal isOpen={showModal} onClose={hideModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading textAlign='left' as='h2' mb={0}>
            {intl.formatMessage(MSG.areYouSure)}
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box>{intl.formatMessage(MSG.doYouWantToDelete)}</Box>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup spacing={3}>
            <Button
              tracking={{
                guid: 'uJPnnYR8Cumv7kRG9z1f88',
                ui_context: HOME_SEARCH_DISMISS_REMOVE_SAVED_SEARCH_MODAL,
                descriptor: 'Dismiss saved search modal'
              }}
              onClick={hideModal}
            >
              {intl.formatMessage(MSG.secondaryBtn)}
            </Button>
            <Button
              tracking={{
                guid: '6k5QUdUq1i9Sbhe2bvjFp9',
                ui_context: HOME_SEARCH_REMOVE_SAVED_SEARCH_MODAL_BUTTON,
                descriptor: 'Remove saved search modal button'
              }}
              colorScheme='danger'
              onClick={handleDeleteSavedSearch}
            >
              {intl.formatMessage(MSG.primaryBtn)}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
